import React from "react";

const HeroSection = () => {
  return (
    <section className="wrapper flex items-center mt-12 min-h-[600px] bg-white">
      <div className="container mx-auto px-4">
        <div className="flex flex-wrap lg:flex-nowrap items-center gap-12">
          {/* Text Content (Left Side) */}
          <div className="w-full lg:w-1/2 order-2 lg:order-1 flex flex-col justify-center my-5">
            <div className="text-start">
              <span className="text-primary font-extrabold text-sm uppercase tracking-wider mb-1 block">
                Transforming Ambitions into Global Achievements
              </span>
              <h1 className="text-heading font-extrabold text-4xl md:text-5xl lg:text-6xl leading-tight mb-6">
                Work, Study & Settle Abroad
              </h1>
              <p className="text-body text-lg md:text-xl font-medium leading-8 mb-12">
                Your one-stop solution in navigating the path to global success.
              </p>
              <div className="read-more-btn">
                <a
                  className="px-6 py-3 bg-primary text-white font-bold text-lg rounded-lg shadow-md hover:bg-blue-600 transition"
                  href="#welcome-to-fetc"
                >
                  Get Started Today
                </a>
              </div>
            </div>
          </div>

          {/* Image Content (Right Side) */}
          <div className="w-full lg:w-1/2 order-1 lg:order-2 flex justify-center">
            <img
              src="/image/hp-banner.png"
              alt="Hero Banner"
              class="w-[300px] h-[300px] sm:w-[300px] sm:h-[300px] md:w-[350px] md:h-[350px] lg:w-[600px] lg:h-[600px] xl:w-[600px] xl:h-[600px]"
              />
          </div>
        </div>
      </div>

      {/* Decorative Shape Images */}
      <div className="absolute -top-10 left-5">
        <img src="/image/shapes/shape-05-03.png" alt="Shape" />
      </div>
      <div className="absolute top-1/5 left-1">
        <img src="/image/shapes/shape-05-04.png" alt="Shape" />
      </div>
      <div className="absolute bottom-5 right-1">
        <img src="/image/shapes/shape-19-04.png" alt="Shape" />
      </div>
      <div className="absolute bottom-20 right-40">
        <img src="/image/shapes/shape-01-04.png" alt="Shape" />
      </div>
      <div className="absolute top-1/3 left-1">
        <img src="/image/shapes/shape-01-03.png" alt="Shape" />
      </div>
      <div className="absolute bottom-1/3 right-2/3">
        <img src="/image/shapes/shape-06.png" alt="Shape" />
      </div>
    </section>
  );
};

export default HeroSection;
